/* eslint-disable @typescript-eslint/ban-ts-comment */
import { FC, PropsWithChildren } from "react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/mousewheel";
import { FreeMode, Mousewheel } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";

import isArrayHasItems from "web/utils/data/validator/array/isArrayHasItems";

import { Classes } from "web/types/Common";

import classify from "web/classify";

import defaultClasses from "./carouselMobile.scss";

interface ICarouselMobileProps {
  classes?: Classes;
  withoutGlider?: boolean;
  withoutOverflow?: boolean;
  freeMode?: boolean;
}

const CarouselMobile: FC<PropsWithChildren<ICarouselMobileProps>> = ({
  classes = {},
  children = null,
  withoutGlider = false,
  withoutOverflow = false,
  freeMode = false,
}) => {
  const rootClassName = `${classes.root || ""} ${classes.scroll || ""}`.trim();
  const rowClasses = withoutOverflow ? classes.rowShort : classes.rowLong;
  return children && isArrayHasItems(children) ? (
    <div className={classes.root}>
      <div className={rowClasses}>
        {!withoutGlider ? (
          <Swiper
            modules={[Mousewheel, FreeMode]}
            slidesPerView="auto"
            mousewheel={{ forceToAxis: true, sensitivity: 2 }}
            className={rootClassName}
            freeMode={freeMode}
          >
            {children?.map((child, index) => (
              // @ts-ignore
              // eslint-disable-next-line react/no-array-index-key
              <SwiperSlide key={child?.key + index}>{child}</SwiperSlide>
            ))}
          </Swiper>
        ) : (
          children
        )}
      </div>
    </div>
  ) : null;
};

export default classify(defaultClasses)(CarouselMobile);
